module.exports = "<button\n    *ngIf=\"data\"\n    type=\"button\"\n    class=\"btn btn-default\"\n    (click)=\"delete()\"\n    [tooltip]=\"'Delete' | translate\"\n    container=\"body\"\n>\n    <i class=\"fal fa-trash-alt text-danger\"></i>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/resources/components/actions/delete/delete.component.html
// module id = ./libs/chassis-core/src/app/resources/components/actions/delete/delete.component.html
// module chunks = main